import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}
  handleError(error) {
    // ErrorHandler is created before the providers, so we need to use Injector for DI here
    if (!environment.production) {
      console.error(error);
    }
  }
}
